// AUTO-GENERATED by scripts/generate-authored-ability-index.ts. Do not edit.
// Regenerate: npm run gen:ability-index

/** Each registration file, loaded on demand (one lazy chunk each). */
export const AUTHORED_ABILITY_REGISTRARS = {
  druid: { exportName: 'registerDruidAbilities', load: () => import('./registerDruidAbilities') },
  hunter: { exportName: 'registerHunterAbilities', load: () => import('./registerHunterAbilities') },
  mage: { exportName: 'registerMageAbilities', load: () => import('./registerMageAbilities') },
  paladin: { exportName: 'registerPaladinAbilities', load: () => import('./registerPaladinAbilities') },
  priest: { exportName: 'registerPriestAbilities', load: () => import('./registerPriestAbilities') },
  rogue: { exportName: 'registerRogueAbilities', load: () => import('./registerRogueAbilities') },
  shaman: { exportName: 'registerShamanAbilities', load: () => import('./registerShamanAbilities') },
  shared: { exportName: 'registerSharedAbilities', load: () => import('./registerSharedAbilities') },
  warlock: { exportName: 'registerWarlockAbilities', load: () => import('./registerWarlockAbilities') },
  warrior: { exportName: 'registerWarriorAbilities', load: () => import('./registerWarriorAbilities') },
} as const;

export type AuthoredRegistrarKey = keyof typeof AUTHORED_ABILITY_REGISTRARS;

/** Authored ability id → the registration file that registers it. */
export const AUTHORED_ABILITY_REGISTRAR: Readonly<Record<string, AuthoredRegistrarKey>> = {
  a_murder_of_crows: 'hunter',
  agility_boost: 'hunter',
  aimed_shot: 'hunter',
  alacrity: 'rogue',
  alter_time: 'mage',
  ambush: 'rogue',
  amplify_magic: 'mage',
  anger_management: 'warrior',
  arcane_barrage: 'mage',
  arcane_barrage_improved: 'mage',
  arcane_blast: 'mage',
  arcane_charges: 'mage',
  arcane_echo: 'mage',
  arcane_explosion: 'mage',
  arcane_familiar: 'mage',
  arcane_harmony: 'mage',
  arcane_intellect: 'mage',
  arcane_missiles: 'mage',
  arcane_orb: 'mage',
  arcane_power: 'mage',
  arcane_shot: 'hunter',
  arcane_surge: 'mage',
  ardent_defender: 'paladin',
  arrow_shot: 'hunter',
  aspect_of_the_cheetah: 'hunter',
  aspect_of_the_hawk: 'hunter',
  aspect_of_the_wild: 'hunter',
  assassin_auto: 'rogue',
  assassin_mastery_1: 'rogue',
  assassin_mastery_10: 'rogue',
  assassin_mastery_2: 'rogue',
  assassin_mastery_3: 'rogue',
  assassin_mastery_4: 'rogue',
  assassin_mastery_5: 'rogue',
  assassin_mastery_6: 'rogue',
  assassin_mastery_7: 'rogue',
  assassin_mastery_8: 'rogue',
  assassin_mastery_9: 'rogue',
  assassinate: 'rogue',
  aura_of_devotion: 'paladin',
  avatar: 'warrior',
  avenger_shield: 'paladin',
  avengers_shield: 'paladin',
  avenging_wrath: 'paladin',
  backstab: 'rogue',
  barbed_shot: 'hunter',
  barkskin: 'druid',
  barrage: 'hunter',
  basic_strike: 'warrior',
  battle_cry: 'warrior',
  battle_shout: 'warrior',
  battle_trance: 'warrior',
  beacon_of_light: 'paladin',
  beast_mastery: 'hunter',
  berserker_rage: 'warrior',
  bestial_wrath: 'hunter',
  between_the_eyes: 'rogue',
  binding_shot: 'hunter',
  bitter_immunity: 'warrior',
  black_arrow: 'hunter',
  blade_fury: 'rogue',
  blade_in_the_dark: 'rogue',
  blade_rush: 'rogue',
  bladestorm: 'warrior',
  blast_wave: 'mage',
  blazing_barrier: 'mage',
  blessed_hammer: 'paladin',
  blessing_of_kings: 'paladin',
  blessing_of_protection: 'paladin',
  blessing_of_seasons: 'paladin',
  blessing_of_spellwarding: 'paladin',
  blind: 'rogue',
  blinding_light: 'paladin',
  blink: 'mage',
  blizzard: 'mage',
  blood_and_thunder: 'warrior',
  bloodbath: 'warrior',
  bloodthirst: 'warrior',
  booming_voice: 'warrior',
  born_to_be_wild: 'hunter',
  brain_freeze: 'mage',
  brightstep: 'priest',
  bulwark_of_order: 'paladin',
  bursting_shot: 'hunter',
  butchery: 'hunter',
  camouflage: 'hunter',
  camouflage_improved: 'hunter',
  careful_aim: 'hunter',
  carve: 'hunter',
  cauterize: 'mage',
  chain_lightning: 'mage',
  chain_strike: 'rogue',
  challenging_shout: 'warrior',
  charge: 'warrior',
  cheat_death: 'rogue',
  chimera_shot: 'hunter',
  cleanse: 'paladin',
  cleave: 'warrior',
  cleaving_strikes: 'warrior',
  cloak_of_shadows: 'rogue',
  cobra_shot: 'hunter',
  cold_blood: 'rogue',
  colossus_smash: 'warrior',
  combustion: 'mage',
  comet: 'mage',
  comet_2: 'mage',
  comet_storm: 'mage',
  commanding_shout: 'warrior',
  concussive_barrage: 'hunter',
  concussive_shot: 'hunter',
  cone_of_cold: 'mage',
  conjure_food: 'mage',
  consecrated_ground: 'paladin',
  consecration: 'paladin',
  coordinated_assault: 'hunter',
  corruption: 'warlock',
  counter_shot: 'hunter',
  counterspell: 'mage',
  crimson_tempest: 'rogue',
  crusader_strike: 'paladin',
  crushing_blow: 'warrior',
  curse_of_agony: 'warlock',
  curse_of_elements: 'warlock',
  curse_of_weakness: 'warlock',
  dagger_shower: 'rogue',
  dark_sight: 'rogue',
  deadly_throw: 'rogue',
  death_chakram: 'hunter',
  death_coil: 'warlock',
  death_from_above: 'rogue',
  death_sweep: 'rogue',
  deathmark: 'rogue',
  deep_freeze: 'mage',
  deeper_daggers: 'rogue',
  deeper_shadows: 'rogue',
  deeper_strategem: 'rogue',
  defensive_mastery: 'warrior',
  defensive_stance: 'warrior',
  demon_armor: 'warlock',
  demoralizing_banner: 'warrior',
  deterrence: 'hunter',
  devastate: 'warrior',
  devotion_aura: 'paladin',
  die_by_the_sword: 'warrior',
  dire_beast: 'hunter',
  disengage: 'hunter',
  dispatch: 'rogue',
  divine_favor: 'paladin',
  divine_intervention: 'paladin',
  divine_purpose: 'paladin',
  divine_purpose_improved: 'paladin',
  divine_resonance: 'paladin',
  divine_shield: 'paladin',
  divine_steed: 'paladin',
  divine_storm: 'paladin',
  divine_toll: 'paladin',
  double_time: 'warrior',
  dragon_breath: 'mage',
  dragon_roar: 'warrior',
  drain_life: 'warlock',
  drain_soul: 'warlock',
  druid_auto: 'druid',
  eagle_companion: 'hunter',
  eagle_eye: 'hunter',
  earthquake: 'warrior',
  echoing_reprimand: 'rogue',
  elaborate_planning: 'rogue',
  empyrean_legacy: 'paladin',
  empyrean_power: 'paladin',
  enduring_rage: 'warrior',
  enrage: 'warrior',
  envenom: 'rogue',
  evasion: 'rogue',
  eviscerate: 'rogue',
  evocation: 'mage',
  execute: 'warrior',
  execution_sentence: 'paladin',
  executioners_precision: 'warrior',
  exhilaration: 'hunter',
  exorcism: 'paladin',
  explosive_shot: 'hunter',
  explosive_trap: 'hunter',
  eye_for_an_eye: 'paladin',
  fan_of_knives: 'rogue',
  fan_of_shadows: 'rogue',
  feign_death: 'hunter',
  feint: 'rogue',
  final_reckoning: 'paladin',
  final_reckoning_2: 'paladin',
  find_weakness: 'rogue',
  fire_blast: 'mage',
  fireball: 'mage',
  firestarter: 'mage',
  fist_of_justice: 'paladin',
  flagellation: 'rogue',
  flame_cannon: 'mage',
  flame_patch: 'mage',
  flamestrike: 'mage',
  flanking_strike: 'hunter',
  flare: 'hunter',
  flash_of_light: 'paladin',
  focused_rage: 'warrior',
  freezing_trap: 'hunter',
  frigid_winds: 'mage',
  frost_bolt: 'mage',
  frost_bomb: 'mage',
  frost_nova: 'mage',
  frostfire_bolt: 'mage',
  frozen_orb: 'mage',
  frozen_touch: 'mage',
  frozen_veins: 'mage',
  fury_of_the_eagle: 'hunter',
  fury_of_the_storm: 'warrior',
  garrote: 'rogue',
  ghost_wolf: 'shaman',
  ghostly_strike: 'rogue',
  glacial_spike: 'mage',
  glacial_veins: 'mage',
  greater_invisibility: 'mage',
  ground_slam: 'warrior',
  guardian_of_ancient_kings: 'paladin',
  guardian_of_the_forgotten_queen: 'paladin',
  hammer_of_justice: 'paladin',
  hammer_of_wrath: 'paladin',
  hammer_throw: 'paladin',
  hamstring: 'warrior',
  hand_of_freedom: 'paladin',
  hand_of_sacrifice: 'paladin',
  harebound: 'druid',
  harpoon: 'hunter',
  haste: 'rogue',
  hawk_eye: 'hunter',
  heal: 'paladin',
  healing_salve: 'hunter',
  healing_stream_totem: 'shaman',
  heroic_leap: 'warrior',
  heroic_throw: 'warrior',
  holy_avenger: 'paladin',
  holy_fire: 'paladin',
  holy_prism: 'paladin',
  holy_radiance: 'paladin',
  holy_shock: 'paladin',
  holy_strike: 'paladin',
  holy_wrath: 'paladin',
  holy_wrath_improved: 'paladin',
  hot_streak: 'mage',
  howl_of_terror: 'warlock',
  hunters_mark: 'hunter',
  hurricane: 'druid',
  ice_barrier: 'mage',
  ice_floes: 'mage',
  ice_lance: 'mage',
  ice_nova: 'mage',
  ice_wall: 'mage',
  icy_veins: 'mage',
  ignore_pain: 'warrior',
  ignore_pain_improved: 'warrior',
  immolate: 'warlock',
  impending_victory: 'warrior',
  indomitable: 'warrior',
  inevitability: 'rogue',
  inferno: 'mage',
  inquisition: 'paladin',
  internal_bleeding: 'rogue',
  intimidating_shout: 'warrior',
  into_the_fray: 'warrior',
  invisibility: 'mage',
  iron_fortress: 'warrior',
  iron_stomach: 'rogue',
  judgment: 'paladin',
  judgment_of_light: 'paladin',
  juggernaut: 'warrior',
  justicars_vengeance: 'paladin',
  justicars_vengeance_improved: 'paladin',
  kidney_shot: 'rogue',
  kill_shot: 'hunter',
  killing_spree: 'rogue',
  kings_grace: 'paladin',
  lanternskip: 'shared',
  last_stand: 'warrior',
  lay_on_hands: 'paladin',
  lay_on_hands_improved: 'paladin',
  leeching_poison: 'rogue',
  life_tap: 'warlock',
  light_of_dawn: 'paladin',
  lightfall: 'priest',
  lightning_bolt: 'shaman',
  living_bomb: 'mage',
  living_flame: 'mage',
  lone_wolf: 'hunter',
  lucky_seven: 'rogue',
  mage_auto: 'mage',
  mage_mastery_1: 'mage',
  mage_mastery_10: 'mage',
  mage_mastery_2: 'mage',
  mage_mastery_3: 'mage',
  mage_mastery_4: 'mage',
  mage_mastery_5: 'mage',
  mage_mastery_6: 'mage',
  mage_mastery_7: 'mage',
  mage_mastery_8: 'mage',
  mage_mastery_9: 'mage',
  mana_gem: 'mage',
  mana_shield: 'mage',
  mark_of_death: 'rogue',
  mark_of_the_wild: 'druid',
  marked_for_death: 'rogue',
  mass_barrier: 'mage',
  mass_polymorph: 'mage',
  mass_spell_reflection: 'warrior',
  master_of_subtlety: 'rogue',
  master_poisoner: 'rogue',
  masters_call: 'hunter',
  menace: 'warrior',
  mend_pet: 'hunter',
  meteor: 'mage',
  meteor_shower: 'mage',
  mirror_image: 'mage',
  moment_of_glory: 'paladin',
  mongoose_bite: 'hunter',
  mortal_strike: 'warrior',
  multi_shot: 'hunter',
  multiple_arrows: 'hunter',
  mutilate: 'rogue',
  muzzle: 'hunter',
  natural_mending: 'hunter',
  net_trap: 'hunter',
  nether_tempest: 'mage',
  nether_ward: 'mage',
  nightblade: 'rogue',
  nightstalker: 'rogue',
  onslaught: 'warrior',
  overpower: 'warrior',
  pact_door: 'warlock',
  paladin_auto: 'paladin',
  paladin_mastery_1: 'paladin',
  paladin_mastery_10: 'paladin',
  paladin_mastery_2: 'paladin',
  paladin_mastery_3: 'paladin',
  paladin_mastery_4: 'paladin',
  paladin_mastery_5: 'paladin',
  paladin_mastery_6: 'paladin',
  paladin_mastery_7: 'paladin',
  paladin_mastery_8: 'paladin',
  paladin_mastery_9: 'paladin',
  perforate: 'rogue',
  perforated_veins: 'rogue',
  phoenix_flames: 'mage',
  piercing_arrow: 'hunter',
  piercing_howl: 'warrior',
  piercing_shot: 'hunter',
  poison_cloud: 'rogue',
  poison_tip: 'hunter',
  polymorph: 'mage',
  posthaste: 'hunter',
  power_word_barrier: 'mage',
  predators_thirst: 'hunter',
  premeditation: 'rogue',
  presence_of_mind: 'mage',
  prey_on_the_weak: 'rogue',
  prismatic_barrier: 'mage',
  pyroblast: 'mage',
  pyromaniac: 'mage',
  radiant_decree: 'paladin',
  raging_blow: 'warrior',
  rain_of_arrows: 'hunter',
  rallying_cry: 'warrior',
  rampage: 'warrior',
  ranger_auto: 'hunter',
  ranger_mastery_1: 'hunter',
  ranger_mastery_10: 'hunter',
  ranger_mastery_3: 'hunter',
  ranger_mastery_4: 'hunter',
  ranger_mastery_5: 'hunter',
  ranger_mastery_6: 'hunter',
  ranger_mastery_7: 'hunter',
  ranger_mastery_8: 'hunter',
  ranger_mastery_9: 'hunter',
  rapid_fire: 'hunter',
  ravager: 'warrior',
  ray_of_frost: 'mage',
  rebuke: 'paladin',
  regrowth: 'druid',
  rejuvenation: 'druid',
  rend: 'warrior',
  resonating_arrow: 'hunter',
  retribution_aura: 'paladin',
  retribution_strike: 'paladin',
  revenge: 'warrior',
  righteous_fury: 'paladin',
  righteous_protector: 'paladin',
  righteous_verdict: 'paladin',
  ring_of_frost: 'mage',
  roar_of_sacrifice: 'hunter',
  rune_of_power: 'mage',
  rupture: 'rogue',
  sacred_shield: 'paladin',
  sacrifice: 'paladin',
  sanctified_ground: 'paladin',
  sanctified_wrath: 'paladin',
  sap: 'rogue',
  scatter_shot: 'hunter',
  scorch: 'mage',
  seal_of_command: 'paladin',
  seal_of_truth: 'paladin',
  searing_totem: 'shaman',
  second_wind: 'warrior',
  secret_technique: 'rogue',
  seed_of_corruption: 'warlock',
  seismic_wave: 'warrior',
  selfless_healer: 'paladin',
  sentinel: 'hunter',
  sentinel_owl: 'hunter',
  sepsis: 'rogue',
  seraphim: 'paladin',
  serpent_sting: 'hunter',
  serrated_blade: 'rogue',
  shadow_blades: 'rogue',
  shadow_cloak: 'rogue',
  shadow_covenant: 'rogue',
  shadow_dance: 'rogue',
  shadow_focus: 'rogue',
  shadow_leap: 'rogue',
  shadow_nova: 'rogue',
  shadow_reflection: 'rogue',
  shadow_step: 'rogue',
  shadow_techniques: 'rogue',
  shadow_vault: 'rogue',
  shadowdust: 'rogue',
  shadowmeld: 'rogue',
  shadowstrike: 'rogue',
  shaman_auto: 'shaman',
  sharp_shooter: 'hunter',
  shatter: 'mage',
  shattering_throw: 'warrior',
  shield_bash: 'warrior',
  shield_charge: 'warrior',
  shield_of_light: 'paladin',
  shield_of_the_righteous: 'paladin',
  shield_of_vengeance: 'paladin',
  shield_slam: 'warrior',
  shield_wall: 'warrior',
  shield_wall_improved: 'warrior',
  shimmer: 'mage',
  shockwave: 'warrior',
  shockwave_improved: 'warrior',
  shuriken_storm: 'rogue',
  shuriken_toss: 'rogue',
  sinister_strike: 'rogue',
  siphon_life: 'warlock',
  skull_banner: 'warrior',
  skullsplitter: 'warrior',
  slam: 'warrior',
  slice_and_dice: 'rogue',
  slow_fall: 'mage',
  smite: 'paladin',
  smoke_bomb: 'rogue',
  snake_hunter: 'hunter',
  snare_trap: 'hunter',
  sniper_shot: 'hunter',
  spell_reflect: 'warrior',
  spellsteal: 'mage',
  spirit_bond: 'hunter',
  spitting_cobra: 'hunter',
  sprint: 'rogue',
  stampede: 'hunter',
  steady_shot: 'hunter',
  steel_trap: 'hunter',
  stomp: 'hunter',
  storm_bolt: 'warrior',
  stormstride: 'shaman',
  subterfuge: 'rogue',
  sudden_death: 'warrior',
  supernova: 'mage',
  survival_instincts: 'hunter',
  sweeping_strikes: 'warrior',
  sword_throw: 'warrior',
  tar_trap: 'hunter',
  taunt: 'warrior',
  templars_verdict: 'paladin',
  temporal_shield: 'mage',
  terms_of_engagement: 'hunter',
  tetherline: 'hunter',
  thistle_tea: 'rogue',
  thrill_of_the_hunt: 'hunter',
  throw_star: 'rogue',
  thunder_clap: 'warrior',
  thunder_stomp: 'warrior',
  time_warp: 'mage',
  titanic_throw: 'warrior',
  toll_the_dead: 'paladin',
  touch_of_the_magi: 'mage',
  toxic_blade: 'rogue',
  tranquility: 'druid',
  tranquilizing_shot: 'hunter',
  travel_form: 'druid',
  tricks_of_the_trade: 'rogue',
  trueshot_aura: 'hunter',
  tyrs_deliverance: 'paladin',
  unbreakable_spirit: 'paladin',
  unstable_affliction: 'warlock',
  vanish: 'rogue',
  vendetta: 'rogue',
  venomous_stab: 'rogue',
  victory_rush: 'warrior',
  virtuous_command: 'paladin',
  volley: 'hunter',
  volley_barrage: 'hunter',
  wake_of_ashes: 'paladin',
  war_banner: 'warrior',
  war_machine: 'warrior',
  warlock_auto: 'warlock',
  warlords_call: 'warrior',
  warpath: 'warrior',
  warrior_auto: 'warrior',
  warrior_mastery_1: 'warrior',
  warrior_mastery_10: 'warrior',
  warrior_mastery_2: 'warrior',
  warrior_mastery_3: 'warrior',
  warrior_mastery_4: 'warrior',
  warrior_mastery_5: 'warrior',
  warrior_mastery_6: 'warrior',
  warrior_mastery_7: 'warrior',
  warrior_mastery_8: 'warrior',
  warrior_mastery_9: 'warrior',
  weaponmaster: 'rogue',
  whirlwind: 'warrior',
  whirlwind_improved: 'warrior',
  wild_spirits: 'hunter',
  wild_strike: 'warrior',
  wildfire_bomb: 'hunter',
  wildfire_shot: 'hunter',
  wind_arrow: 'hunter',
  windfury_totem: 'shaman',
  wings_of_liberty: 'paladin',
  winter_chill: 'mage',
  word_of_glory: 'paladin',
  wrecking_ball: 'warrior',
  wyvern_sting: 'hunter',
  zeal: 'paladin',
};
